import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CandidatesState } from '../reducers/base-candidates.reducer';

const getCandidatesState = createFeatureSelector<CandidatesState>('candidates');

export const getCandidates = createSelector(getCandidatesState, (state) => state.candidates);
export const getCandidateProfile = createSelector(getCandidatesState, (state) => state.candidate);
export const getCreateCandidateId = createSelector(getCandidatesState, (state) => state.candidate.id);

export const getDocument = createSelector(getCandidatesState, (state) => state.document);
export const getDownloadDocument = createSelector(getCandidatesState, (state) => state.downloadDocument);

export const getAbsences = createSelector(getCandidatesState, (state) => state.absences.list);
export const getAbsenceSummary = createSelector(getCandidatesState, (state) => state.absences.summary);
export const getAbsenceConflicts = createSelector(getCandidatesState, (state) => state.absences.conflicts);

export const getProfileAccountInformationData = createSelector(getCandidatesState, (state) => state.account.data);
export const getProfileAccountReactivatedStatus = createSelector(
  getCandidatesState,
  (state) => state.account.reactivated
);
export const getCandidateResponsibleUserList = createSelector(getCandidatesState, (state) => state.responsibleUserList);
export const getCandidateLeavingDateConflicts = createSelector(
  getCandidatesState,
  (state) => state.leavingDateConflicts
);
export const getCandidateProfileDocuments = createSelector(
  getCandidatesState,
  (state) => state.candidateProfileDocuments
);
